export enum FontCreatorActionListEnum {
  SET_FONTS = 'fonts:set',
  CREATE_FONT = 'font:create',
  UPDATE_FONT = 'font:update',
  SAVE_SYMBOL = 'font:symbol:save',
}
